import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'

// TransitionMaterial - inline component
function TransitionMaterial({ transitionColor, transitionTime = 0.25, ...props }) {
  const materialRef = useRef()

  useFrame((_, delta) => {
    if (materialRef.current) {
      easing.dampC(materialRef.current.color, transitionColor, transitionTime, delta)
    }
  })

  return <meshPhysicalMaterial ref={materialRef} {...props} />
}

export default function Model1({ transitionColor, ...props }) {
  const { nodes, materials } = useGLTF('/assets/models/model1.glb')

  const ledRef = useRef()
  const ledRef2 = useRef()

  useFrame((state) => {
    const t = state.clock.getElapsedTime()
    const hue = (t * 0.2) % 1

    if (ledRef.current) {
      ledRef.current.material.color.setHSL(hue, 1, 0.5)
      ledRef.current.material.emissive.setHSL(hue, 1, 0.5)
      ledRef.current.material.emissiveIntensity = 5
    }

    if (ledRef2.current) {
      ledRef2.current.material.color.setHSL(hue, 1, 0.5)
      ledRef2.current.material.emissive.setHSL(hue, 1, 0.5)
      ledRef2.current.material.emissiveIntensity = 5
    }
  })

  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]} scale={0.167}>
          <group name="root">
            <group name="GLTF_SceneRootNode" rotation={[Math.PI / 2, 0, 0]}>
              <group
                name="Razer_Basilisk_grp_37"
                position={[-0.127, -0.007, -0.001]}
                rotation={[Math.PI / 2, 0, 0]}
                scale={0.01}>
                <group name="Btm_Btn_geo_0">
                  <mesh name="Object_5" castShadow receiveShadow geometry={nodes.Object_5.geometry}>
                    <TransitionMaterial roughness={0.5} transitionColor={transitionColor} metalness={0} />
                  </mesh>
                </group>
                <group name="Btm_Decal_geo_1">
                  <mesh name="Object_7" castShadow receiveShadow geometry={nodes.Object_7.geometry} material={materials.Decal_MAT} />
                </group>
                <group
                  name="Btm_Fill_geo_2"
                  position={[-5.55, 0.348, -3.436]}
                  rotation={[Math.PI, 0, Math.PI]}
                  scale={[20.58, 20.58, 16.276]}>
                  <mesh name="Object_9" castShadow receiveShadow geometry={nodes.Object_9.geometry} material={materials.Dull_Tracker_MAT} />
                </group>
                <group name="Btm_Foor_Center_geo_3">
                  <mesh name="Object_11" castShadow receiveShadow geometry={nodes.Object_11.geometry} material={materials.Feet_Rubber_MAT} />
                </group>
                <group name="CenterBtn01_geo_4">
                  <mesh name="Object_13" castShadow receiveShadow geometry={nodes.Object_13.geometry} material={materials.Matte_Plastic_MAT} />
                </group>
                <group name="CenterBtn02_geo_5">
                  <mesh name="Object_15" castShadow receiveShadow geometry={nodes.Object_15.geometry} material={materials.Matte_Plastic_MAT} />
                </group>
                <group name="Click_Decal_geo_6">
                  <mesh name="Object_17" castShadow receiveShadow geometry={nodes.Object_17.geometry} material={materials.Click_Decal_MAT} />
                </group>
                <group name="L_Click_geo_7">
                  <mesh name="Object_19" castShadow receiveShadow geometry={nodes.Object_19.geometry}>
                    <TransitionMaterial roughness={0.5} transitionColor={transitionColor} metalness={0} />
                  </mesh>
                </group>
                <group name="Led_Btm_geo_8">
                  <mesh ref={ledRef} name="Object_21" castShadow receiveShadow geometry={nodes.Object_21.geometry} material={materials.LED_MAT} />
                  <mesh ref={ledRef2} name="Object_21001" castShadow receiveShadow geometry={nodes.Object_21001.geometry}>
                    <meshPhysicalMaterial color="green" roughness={0.1} metalness={0.8} />
                  </mesh>
                </group>
                <group name="Left_Btn_Fill_geo_9">
                  <mesh name="Object_23" castShadow receiveShadow geometry={nodes.Object_23.geometry} material={materials.Matte_Plastic_Dull_MAT} />
                </group>
                <group name="Left_Handle_geo_10">
                  <mesh name="Object_25" castShadow receiveShadow geometry={nodes.Object_25.geometry} material={materials.Grip_Plastic_MAT} />
                </group>
                <group name="LeftBtn_Large_geo_11">
                  <mesh name="Object_27" castShadow receiveShadow geometry={nodes.Object_27.geometry} material={materials.Shiny_Plastic_MAT} />
                </group>
                <group name="LeftBtn_Small1_geo_12">
                  <mesh name="Object_29" castShadow receiveShadow geometry={nodes.Object_29.geometry} material={materials.Shiny_Plastic_MAT} />
                </group>
                <group name="LeftBtn_Small2_geo_13">
                  <mesh name="Object_31" castShadow receiveShadow geometry={nodes.Object_31.geometry} material={materials.Shiny_Plastic_MAT} />
                </group>
                <group name="LeftClick_Fill_geo_14">
                  <mesh name="Object_33" castShadow receiveShadow geometry={nodes.Object_33.geometry} material={materials.Matte_Plastic_Dull_MAT} />
                </group>
                <group name="Mouse_Base_geo_15">
                  <mesh name="Object_35" castShadow receiveShadow geometry={nodes.Object_35.geometry}>
                    <TransitionMaterial roughness={0.5} transitionColor={transitionColor} metalness={0} />
                  </mesh>
                </group>
                <group name="Mouse_Foot_Btm_geo_16" position={[0, 0, -8.462]}>
                  <mesh name="Object_37" castShadow receiveShadow geometry={nodes.Object_37.geometry} material={materials.Feet_Rubber_MAT} />
                </group>
                <group name="Mouse_Foot_Side_geo_17" position={[27.691, 0, -3.177]} scale={9.729}>
                  <mesh name="Object_39" castShadow receiveShadow geometry={nodes.Object_39.geometry} material={materials.Feet_Rubber_MAT} />
                </group>
                <group name="Mouse_Foot_Top_L_geo_18" position={[5.331, 37.647, -4.715]} scale={9.714}>
                  <mesh name="Object_41" castShadow receiveShadow geometry={nodes.Object_41.geometry} material={materials.Feet_Rubber_MAT} />
                </group>
                <group
                  name="Mouse_Foot_Top_R_geo_19"
                  position={[-16.687, 41.173, -4.706]}
                  rotation={[Math.PI, 0, Math.PI]}
                  scale={9.714}>
                  <mesh name="Object_43" castShadow receiveShadow geometry={nodes.Object_43.geometry} material={materials.Feet_Rubber_MAT} />
                </group>
                <group name="MouseWheel_grp_25">
                  <group name="MouseWheel_Detail_geo_20">
                    <mesh name="Object_46" castShadow receiveShadow geometry={nodes.Object_46.geometry} material={materials.Translucent_Plastic_MAT} />
                  </group>
                  <group name="pCylinder2_21">
                    <mesh name="Object_48" castShadow receiveShadow geometry={nodes.Object_48.geometry} material={materials.Translucent_Plastic_MAT} />
                  </group>
                  <group name="polySurface7_22">
                    <mesh name="Object_50" castShadow receiveShadow geometry={nodes.Object_50.geometry} material={materials.LED_MAT} />
                  </group>
                  <group name="polySurface8_23">
                    <mesh name="Object_52" castShadow receiveShadow geometry={nodes.Object_52.geometry} material={materials.Matte_Plastic_MAT} />
                  </group>
                  <group name="polySurface9_24">
                    <mesh name="Object_54" castShadow receiveShadow geometry={nodes.Object_54.geometry} material={materials.Matte_Plastic_MAT} />
                  </group>
                </group>
                <group name="MouseWheel_Light_geo_26" rotation={[-Math.PI / 2, 0, 0]} scale={100}>
                  <mesh name="Object_56" castShadow receiveShadow geometry={nodes.Object_56.geometry} material={materials.LED_MAT} />
                </group>
                <group name="R_Click_geo_27">
                  <mesh name="Object_58" castShadow receiveShadow geometry={nodes.Object_58.geometry}>
                    <TransitionMaterial roughness={0.5} transitionColor={transitionColor} metalness={0} />
                  </mesh>
                </group>
                <group name="Right_Handle_geo_28">
                  <mesh name="Object_60" castShadow receiveShadow geometry={nodes.Object_60.geometry} material={materials.Grip_Plastic_MAT} />
                </group>
                <group name="RightClick_Fill_geo_29">
                  <mesh name="Object_62" castShadow receiveShadow geometry={nodes.Object_62.geometry} material={materials.Matte_Plastic_Dull_MAT} />
                </group>
                <group name="Top_Shiny_geo001_31">
                  <mesh name="Object_66" castShadow receiveShadow geometry={nodes.Object_66.geometry} material={materials.Shiny_Plastic_MAT} />
                </group>
                <group name="Top_Shiny_geo1_32">
                  <mesh name="Object_68" castShadow receiveShadow geometry={nodes.Object_68.geometry} material={materials.Dull_MAT} />
                </group>
                <group name="TopCover_geo_33">
                  <mesh name="Object_70" castShadow receiveShadow geometry={nodes.Object_70.geometry}>
                    <TransitionMaterial roughness={0.5} transitionColor={transitionColor} metalness={0} />
                  </mesh>
                </group>
                <group name="TrackerGlass_geo_34">
                  <mesh name="Object_72" castShadow receiveShadow geometry={nodes.Object_72.geometry} material={materials.Tracker_Glass_MAT} />
                </group>
                <group
                  name="Wheel_Base_geo002_35"
                  position={[12.653, 24.577, -7.169]}
                  rotation={[-1.181, 0, 0]}
                  scale={21.291}>
                  <mesh name="Object_74" castShadow receiveShadow geometry={nodes.Object_74.geometry} material={materials.Shiny_Plastic_MAT} />
                </group>
                <group name="WheelHole_Dull_geo_36">
                  <mesh name="Object_76" castShadow receiveShadow geometry={nodes.Object_76.geometry} material={materials.Dull_MAT} />
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/assets/models/model1.glb')
